<!--The content below is only a placeholder and can be replaced.-->
<div style="text-align:center">
  <h1>
    Welcome to {{ title }}!
  </h1>
</div>
<div align="center">
  <nav>
    <a routerLink="/" routerLinkActive="active">Home</a>
    &nbsp;
    <a routerLink="/profile" routerLinkActive="active">Profile</a>
    &nbsp;
    <style>
      .bmc-button img {
        height: 34px !important;
        width: 35px !important;
        margin-bottom: 1px !important;
        box-shadow: none !important;
        border: none !important;
        vertical-align: middle !important;
      }

      .bmc-button {
        padding: 7px 15px 7px 10px !important;
        line-height: 35px !important;
        height: 51px !important;
        text-decoration: none !important;
        display: inline-flex !important;
        color: #FFFFFF !important;
        background-color: #FF813F !important;
        border-radius: 5px !important;
        border: 1px solid transparent !important;
        padding: 7px 15px 7px 10px !important;
        font-size: 22px !important;
        letter-spacing: 0.6px !important;
        box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5) !important;
        -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
        margin: 0 auto !important;
        font-family: 'Cookie', cursive !important;
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
      }

      .bmc-button:hover,
      .bmc-button:active,
      .bmc-button:focus {
        -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
        text-decoration: none !important;
        box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
        opacity: 0.85 !important;
        color: #FFFFFF !important;
      }
    </style>
    <link href="https://fonts.googleapis.com/css?family=Cookie" rel="stylesheet"><a class="bmc-button" target="_blank"
      href="https://www.buymeacoffee.com/7thelement"><img
        src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"><span
        style="margin-left:5px;font-size:28px !important;">Buy me a coffee</span></a>
  </nav>
</div>

<router-outlet></router-outlet>